// extracted by mini-css-extract-plugin
export var button = "_do-7";
export var buttonRow = "_do-6";
export var fadeIn = "_do-1";
export var gradient = "_do-0";
export var panel = "_do-2";
export var panelIn = "_do-3";
export var subtitle = "_do-5";
export var title = "_do-4";